(() => {
  if (window.kaguyasuProductReviewsBound) return;
  window.kaguyasuProductReviewsBound = true;

  const reviewWidget = () => document.querySelector('#judgeme_product_reviews');
  const moveTo = (target) => {
    if (!target) return;
    const header = document.querySelector('#shopify-section-header');
    const offset = Math.min(header ? header.getBoundingClientRect().height : 0, 220) + 20;
    const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
    window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  };
  const activate = (name) => {
    document.querySelectorAll('[data-product-panel]').forEach((button) => {
      const active = button.dataset.productPanel === name;
      button.closest('li').classList.toggle('active', active);
      if (active) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });
  };
  const showReviews = () => {
    const widget = reviewWidget();
    if (!widget) return;
    activate('reviews');
    document.querySelectorAll('.product-tabs .tab-description, .product-recommendations').forEach((node) => {
      node.style.display = 'none';
    });
    widget.hidden = false;
    window.requestAnimationFrame(() => moveTo(widget));
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-product-panel]');
    if (button) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const name = button.dataset.productPanel;
      activate(name);
      if (name === 'reviews') {
        showReviews();
        return;
      }
      document.querySelectorAll('.product-tabs .tab-description').forEach((node) => {
        node.style.display = name === 'description' ? '' : 'none';
      });
      document.querySelectorAll('.product-recommendations').forEach((node) => {
        node.style.display = name === 'recommendations' ? '' : 'none';
      });
      return;
    }
    const badge = event.target.closest('.product__info-container .jdgm-preview-badge, .hys-image-text .jdgm-preview-badge, .product-write-review, .rating-links a');
    if (!badge || !badge.closest('main') || !reviewWidget()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showReviews();
  }, true);

  const prepareBadges = () => {
    if (!reviewWidget()) return;
    document.querySelectorAll('.product__info-container .jdgm-preview-badge, .hys-image-text .jdgm-preview-badge').forEach((badge) => {
      badge.dataset.kaguyasuReviewLink = '';
      badge.setAttribute('aria-controls', 'judgeme_product_reviews');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareBadges, { once: true });
  else prepareBadges();
  document.addEventListener('shopify:section:load', prepareBadges);
})();
